import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { LegendCategory, OLLegendDefinition } from 'src/app/models/layer';

@Component({
    selector: 'app-atlas-mobile-legend',
    templateUrl: './atlas-mobile-legend.component.html',
    styleUrls: ['./atlas-mobile-legend.component.scss'],
})
export class AtlasMobileLegendComponent implements OnInit {
    public legendCategories: LegendCategory[];
    public legend: OLLegendDefinition;
    public detailedLegend: boolean = true;
    constructor(private readonly router: Router, private readonly cd: ChangeDetectorRef) {}
    ngOnInit() {
        this.legend = {
            values: [
                { position: 0, label: '0' },
                { position: 1, label: '50' },
                { position: 2, label: '100' },
            ],
        };
        this.detailedLegend = this.router.url.includes('selectedTab=detailed');
        this.cd.detectChanges();
        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.detailedLegend = event.url.includes('selectedTab=detailed');
            this.cd.detectChanges();
        });

        this.legendCategories = [
            { label: 'DEEPINDOOR', color: '#00cc00' }, // green
            { label: 'INDOOR', color: '#d3ec28' }, // yellow-green
            { label: 'OUTDOOR', color: '#e6d995' }, // beige
            { label: 'NOSIGNAL', color: '#d9534f' }, // red
        ];
    }
}
